import { createActionTypes } from "@helpers/redux-helpers";

export const getCountersActionTypes = createActionTypes("statistics/counters");
export const getSalesActionTypes = createActionTypes("statistics/sales");

export const getDistributionsActionTypes = createActionTypes(
  "statistics/distributions",
);

export const getTransactionsActionTypes = createActionTypes(
  "statistics/transactions",
);

export const getIncomeActionTypes = createActionTypes("statistics/income");

export const downloadCsvActionTypes = createActionTypes("statistics/csv");

export const csvLinkReceivedActionTypes = createActionTypes(
  "statistics/csv/link/received",
);
